module.exports = __webpack_public_path__ + "img/button.96a04421.png";